import { render } from "./RecordMalfunction.vue?vue&type=template&id=130a0d94&scoped=true"
import script from "./RecordMalfunction.vue?vue&type=script&language=ts&lang=js"
export * from "./RecordMalfunction.vue?vue&type=script&language=ts&lang=js"

import "./RecordMalfunction.vue?vue&type=style&index=0&id=130a0d94&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-130a0d94"

export default script